import React from 'react';
import classNames from 'classnames';

import './MenuToggleButton.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {solid} from '@fortawesome/fontawesome-svg-core/import.macro';

interface MenuToggleButtonProps {
  hidden?: boolean;
  onClick: () => void;
}

export const MenuToggleButton = ({ hidden, onClick }: MenuToggleButtonProps) => {
  return (
    <div onClick={onClick} className={classNames('menu-toggle-button', { 'menu-toggle-button--hidden': hidden })}>
      <FontAwesomeIcon
        icon={hidden ? solid('list') : solid('times')}
        className={hidden ? 'menu-toggle-button__icon-open' : 'menu-toggle-button__icon-close'}
        fixedWidth
      />
    </div>
  );
};
